import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hickoryConfig } from "./data";

export default function HickoryPage() {
  return <CityPageTemplate config={hickoryConfig} />;
}